import { Id, TextField } from "@dgs/core";
import { ReactNode } from "react";
import { DataFieldIndexResource } from "../../types/dataField";
import {
	ContactAttributeRequest,
	IContactAttributeBaseHandler,
	IContactAttributeHandler,
	IContactAttributeListHandler,
} from "../IContactAttributeHandler";

export function createEmailDataFieldContactAttributeBaseHandler(
	id: Id,
	dataField: DataFieldIndexResource,
): IContactAttributeBaseHandler {
	return {
		type: "EMAIL_DATA_FIELD",
		id,
		getLabel: () => dataField.label,
	};
}

export function createEmailDataFieldContactAttributeProfileHandler(
	id: Id,
	value: string | null,
	dataField: DataFieldIndexResource,
): IContactAttributeHandler<string, string | null> {
	const baseHandler = createEmailDataFieldContactAttributeBaseHandler(id, dataField);
	return {
		...baseHandler,
		value,
		validate() {
			return null;
		},
		renderValue(): ReactNode {
			return this.value ?? "";
		},
		renderFormField(t, prefix): ReactNode {
			return (
				<TextField
					name={`${prefix ? `${prefix}.` : ""}${id}.value`}
					label={baseHandler.getLabel(t)}
					placeholder={dataField.placeholder}
					description={dataField.description}
				/>
			);
		},
		toRequestValue(): ContactAttributeRequest<string> {
			return { id, value: this.value ?? "" };
		},
	};
}

export function createEmailDataFieldContactAttributeListHandler(
	id: Id,
	dataField: DataFieldIndexResource,
): IContactAttributeListHandler {
	const baseHandler = createEmailDataFieldContactAttributeBaseHandler(id, dataField);
	return {
		...baseHandler,
		getColumnSize: () => "max-content",
	};
}
